import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'eyrus-question-type',
  templateUrl: './question-type.component.html',
  styleUrls: ['./question-type.component.sass']
})
export class QuestionTypeComponent implements OnInit {

  @Input() questionTypes: any[] = [];
  @Input() itemType: any = {};

  typeData: any = {};

  constructor() { }

  ngOnInit() {
    this.getSelection();
  }

  getSelection() {
    this.typeData = this.questionTypes.find(item => {
      return item.questionTypeId.toString() === this.itemType.toString();
    }) || {};
  }
}
